import env from '../config/env';

export const SERVER_URL = env.API_BASE_URL;
export const BASE_URL = `${SERVER_URL}/api/`;
export const LOGIN_USER = '/login-user';
// export const GET_PRODUCT = 'get-product/provision';
export const ADD_CATEGORY = 'add-category';
export const EDIT_CATEGORY = 'edit-category';
export const GET_CITIES = 'get-cities';
export const GET_USER_PROFILE = 'get-user-profile/provision';
export const CHANGE_LANGUAGE = 'change-language/provision';
export const MANAGE_MASTER_PASSWORD = 'manage-master-password';

export const SEND_MESSAGES = 'send-messages/provision';
export const GET_MESSAGE_LIST = 'get-message-list/provision';
export const REPLY_MESSAGE = 'reply-message/provision';
export const GET_REPLIES = 'get-replies/provision';
export const CHANGE_MESSAGE_STATUS = 'change-message-status/provision';
export const GET_NAMES = 'get-names/provision';
export const DELETE_MESSAGE = 'delete-message/provision';
export const GET_NEW_MESSAGE_COUNT = 'get-new-message-count/provision';

export const GET_PRODUCTS = 'get-products/provision';
export const CREATE_PRODUCT = 'create-product';
export const UPDATE_PROFILE = 'update-profile/provision';
export const PROFILE_IMAGE_UPLOAD = 'profile-image-upload/provision';
export const GET_ALL_STORES = 'get-all-stores/provision';
export const GET_STORE = 'get-store/provision';
export const GET_SUBCATEGORIES_LIST = 'get-subcategories-list';
export const ADD_SUBCATEGORY = 'add-subcategory';
export const EDIT_SUBCATEGORY = 'edit-subcategory';
export const GET_SUPPLIERS = 'get-suppliers';
export const GET_SUPPLIER = 'get-supplier';
export const CREATE_SUPPLIER = 'create-supplier';
export const EDIT_SUPPLIER = 'edit-supplier';
export const REACTIVE_SUPPLIER = 'reactive-supplier';
export const DEACTIVE_SUPPLIER = 'deactive-supplier';
export const USER_LOGO = 'user-logo/supplier';
export const UPDATE_PASSWORD = 'update-password/provision';

export const GET_TAXES = 'get-taxes/provision';
export const CREATE_TAXES = 'create-taxes/provision';

export const GET_COUNTRY_LIST = 'get-country-list/provision';
export const GET_STATE_LIST = 'get-state-list/provision';
